import React from 'react';
import { ListItemButton, ListItemProps } from '@mui/material';
import { useSelectableListContext } from './SelectableListContext';


export type SelectableListItemProps<
  D extends React.ElementType = 'li',
  P = {}
> = ListItemProps<D, P> & {
  value: string | number;
};


export const SelectableListItem = React.forwardRef(<
  D extends React.ElementType = 'li',
  P = {}
>(props: SelectableListItemProps<D, P>, ref: React.Ref<HTMLDivElement>) => {
  const selectableListContext = useSelectableListContext();
  const checked = selectableListContext.value === props.value;

  return (
    <ListItemButton
      {...props}
      ref={ref}
      selected={checked}
      onClick={() => selectableListContext.onChange(props.value)}
    >
      {props.children}
    </ListItemButton>
  );
});
